var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "byhand" }, [
    _c("h1", [_vm._v("Конструктор круизов")]),
    _vm._v(" "),
    _setup.testappUse
      ? _c("div", { staticClass: "byhand--fill-test" }, [
          _c("button", { on: { click: _setup.byhand_fill_test } }, [
            _vm._v("заполнить круиз тестовыми данными"),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_setup.dict.towns
      ? _c(
          "div",
          { staticClass: "CruisePage__ifloader" },
          [_c(_setup.Loader, { staticClass: "CruisePage__loader" })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _setup.dict.towns
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "bhform" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  _setup.MyMulti,
                  {
                    staticClass: "bhform-row",
                    class: { red: _setup.isRed("oper_id") },
                    attrs: {
                      classinput: "bhform-row--input",
                      list: _setup.dict.opers,
                      onlyone: true,
                      choosed: _setup.nov.oper_id,
                      placeholder: "...",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.select("oper_id", $event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "bhform-row--title" }, [
                      _vm._v("Туроператор"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  _setup.MyMulti,
                  {
                    staticClass: "bhform-row",
                    class: { red: _setup.isRed("stown_id") },
                    attrs: {
                      classinput: "bhform-row--input",
                      list: _setup.dict.towns,
                      onlyone: true,
                      choosed: _setup.nov.stown_id,
                      placeholder: "...",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.select("stown_id", $event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "bhform-row--title" }, [
                      _vm._v("Город отправления"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title" }, [
                    _vm._v("Дата отправления"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bhform-row--input" },
                    [
                      _c(_setup.DatePick, {
                        staticClass: "custom-datepick bhform-row--input",
                        class: { red: _setup.isRed("date") },
                        attrs: {
                          value: _setup.nov.date,
                          format: _setup.format,
                          nextMonthCaption: _setup.nextMonthCaption,
                          prevMonthCaption: _setup.prevMonthCaption,
                          setTimeCaption: _setup.setTimeCaption,
                          weekdays: _setup.weekdays,
                          months: _setup.months,
                          selectableYearRange: 2,
                        },
                        on: {
                          input: function ($event) {
                            return _setup.select("date", $event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _setup.isRed("date")
                        ? _c("span", { staticClass: "fieldError" }, [
                            _vm._v(_vm._s(_setup.errorField("date"))),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title" }, [
                    _vm._v("Дней"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bhform-row--input" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        class: { red: _setup.isRed("nights") },
                        domProps: { value: _setup.nov.nights },
                        on: {
                          input: function ($event) {
                            return _setup.select("nights", $event.target.value)
                          },
                        },
                      },
                      _vm._l(_setup.nights_options, function (option) {
                        return _c(
                          "option",
                          { domProps: { value: option.id } },
                          [_vm._v(_vm._s(option.name))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  _setup.MyMulti,
                  {
                    staticClass: "bhform-row",
                    class: { red: _setup.isRed("ship_id") },
                    attrs: {
                      classinput: "bhform-row--input",
                      list: _setup.dict.shipsWnd,
                      onlyone: true,
                      choosed: _setup.nov.ship_id,
                      placeholder: "...",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.select("ship_id", $event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "bhform-row--title" }, [
                      _vm._v("Теплоход"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  _setup.MyMulti,
                  {
                    staticClass: "bhform-row",
                    class: { red: _setup.isRed("btown_id") },
                    attrs: {
                      classinput: "bhform-row--input",
                      list: _setup.dict.towns,
                      onlyone: true,
                      choosed: _setup.nov.btown_id,
                      placeholder: "...",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.select("btown_id", $event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "bhform-row--title" }, [
                      _vm._v("Город прибытия"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title bhform-price" }, [
                    _vm._v("Цена"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "bhform-row--input bhform-price--a" },
                    [
                      _c("input", {
                        staticClass: "custom-input",
                        class: { red: _setup.isRed("price") },
                        attrs: { type: "text" },
                        domProps: { value: _setup.nov.price },
                        on: {
                          input: function ($event) {
                            _setup.select("price", $event.target.value.trim())
                          },
                        },
                      }),
                      _vm._v(" "),
                      _setup.isRed("price")
                        ? _c("span", { staticClass: "fieldError" }, [
                            _vm._v(_vm._s(_setup.errorField("price"))),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "bhform--price-b" }, [
                    _c(
                      "select",
                      {
                        staticClass: "custom-select",
                        class: { red: _setup.isRed("currency_id") },
                        domProps: { value: _setup.nov.currency_id },
                        on: {
                          input: function ($event) {
                            return _setup.select(
                              "currency_id",
                              $event.target.value
                            )
                          },
                        },
                      },
                      _vm._l(_setup.currency_options, function (option) {
                        return _c(
                          "option",
                          { domProps: { value: option.id } },
                          [_vm._v(_vm._s(option.name))]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title" }, [
                    _vm._v("Каюта (желательно)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bhform-row--input" }, [
                    _c("input", {
                      staticClass: "custom-input",
                      class: { red: _setup.isRed("cabin_name") },
                      attrs: { type: "text" },
                      domProps: { value: _setup.nov.cabin_name },
                      on: {
                        input: function ($event) {
                          _setup.select(
                            "cabin_name",
                            $event.target.value.trim()
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _setup.isRed("cabin_name")
                      ? _c("span", { staticClass: "fieldError" }, [
                          _vm._v(_vm._s(_setup.errorField("cabin_name"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title" }, [
                    _vm._v("Тип каюты (желательно)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bhform-row--input" }, [
                    _c("input", {
                      staticClass: "custom-input",
                      class: { red: _setup.isRed("type_name") },
                      attrs: { type: "text" },
                      domProps: { value: _setup.nov.type_name },
                      on: {
                        input: function ($event) {
                          _setup.select("type_name", $event.target.value.trim())
                        },
                      },
                    }),
                    _vm._v(" "),
                    _setup.isRed("type_name")
                      ? _c("span", { staticClass: "fieldError" }, [
                          _vm._v(_vm._s(_setup.errorField("type_name"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title" }, [
                    _vm._v("Палуба (желательно)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bhform-row--input" }, [
                    _c("input", {
                      staticClass: "custom-input",
                      class: { red: _setup.isRed("deck_name") },
                      attrs: { type: "text" },
                      domProps: { value: _setup.nov.deck_name },
                      on: {
                        input: function ($event) {
                          _setup.select("deck_name", $event.target.value.trim())
                        },
                      },
                    }),
                    _vm._v(" "),
                    _setup.isRed("deck_name")
                      ? _c("span", { staticClass: "fieldError" }, [
                          _vm._v(_vm._s(_setup.errorField("deck_name"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "bhform-row" }, [
                  _c("div", { staticClass: "bhform-row--title" }, [
                    _vm._v("Ссылка на круиз (желательно)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bhform-row--input" }, [
                    _c("input", {
                      staticClass: "custom-input",
                      class: { red: _setup.isRed("tour_url") },
                      attrs: { type: "text" },
                      domProps: { value: _setup.nov.tour_url },
                      on: {
                        input: function ($event) {
                          _setup.select("tour_url", $event.target.value.trim())
                        },
                      },
                    }),
                    _vm._v(" "),
                    _setup.isRed("tour_url")
                      ? _c("span", { staticClass: "fieldError" }, [
                          _vm._v(_vm._s(_setup.errorField("tour_url"))),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cabins-guests__header",
                staticStyle: { "margin-top": "30px" },
              },
              [_vm._v("Выберите размещение")]
            ),
            _vm._v(" "),
            _c(_setup.SelectOccupation, {
              attrs: { Cabin: _setup.cstore.getCabinCons.Cabin },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "cabins-guests__header" }, [
              _vm._v("Пассажиры"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cabins-guests__content" }, [
              _c("div", { staticClass: "cabins-guests__section" }, [
                _c(
                  "div",
                  { staticClass: "cabin" },
                  [
                    _c("div", { staticClass: "cabin__wrapper" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cabin__content cabin-content" },
                        [
                          _vm._l(
                            _setup.cstore.getCabinCons.places,
                            function (place) {
                              return [
                                _c(_setup.FillPlace, {
                                  key: place.pnum,
                                  staticClass: "cabin-content__place",
                                  attrs: {
                                    place: place,
                                    cabinId: _setup.cstore.getCabinCons.id,
                                    Cabin: _setup.cstore.getCabinCons.Cabin,
                                    ages: _setup.cstore.getCabinCons.ages,
                                  },
                                }),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(_setup.CabinErrors, {
                      attrs: {
                        errors:
                          _setup.cabinErrors[_setup.cstore.getCabinCons.id],
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cabins-guests__section" }, [
                _c(
                  "div",
                  { staticClass: "cabin" },
                  [
                    _c("div", { staticClass: "cabin__wrapper" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cabin__content cabin-content" },
                        [
                          _c(_setup.FillPlace, {
                            staticClass: "cabin__persons__place",
                            attrs: {
                              place: _setup.bookCabins.customerCabinPlace,
                              cabinId: _setup.bookCabins.customerCabinId,
                              validationMode: "strict",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(_setup.CabinErrors, {
                      attrs: { errors: _setup.cabinErrors[_setup.cuCabin] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cabin",
                    staticStyle: { "grid-column": "span 2" },
                  },
                  [
                    _c("div", { staticClass: "cabin__wrapper" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "cabin__content cabin-content" },
                        [
                          _c("div", { staticClass: "cabin-content__comment" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _setup.bookCabins.notes_note,
                                  expression: "bookCabins.notes_note",
                                },
                              ],
                              attrs: {
                                placeholder: "Ваш комментарий к заказу",
                              },
                              domProps: { value: _setup.bookCabins.notes_note },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _setup.bookCabins,
                                    "notes_note",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cabin-content__checkbox-options" },
                            [
                              _c(
                                _setup.MyCheckbox,
                                {
                                  attrs: {
                                    choosed: _setup.bookCabins.notes_attachDoc,
                                  },
                                  on: {
                                    input: function ($event) {
                                      _setup.bookCabins.notes_attachDoc = $event
                                    },
                                  },
                                },
                                [_c("span", [_vm._v("Пенсионная скидка")])]
                              ),
                              _vm._v(" "),
                              _setup.bookCabins.notes_attachDoc
                                ? _c("div", [
                                    _vm._v(
                                      "Для подтверждения скидки прикрепите пенсионное удостоверение после сохранения заявки"
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "byhand-submit" }, [
              _setup.errors.length
                ? _c(
                    "div",
                    { staticClass: "error-list byhand-submit--a" },
                    [
                      _c("div", [_vm._v("Обнаружено следующее:")]),
                      _vm._v(" "),
                      _vm._l(_setup.errors, function ({ text }) {
                        return _c("div", { staticClass: "error-list--li" }, [
                          _vm._v(_vm._s(text)),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _setup.nov.ship_id && _setup.getShip().is_sea
                ? _c("div", { staticClass: "byhand-submit--warn" }, [
                    _vm._v(
                      "\n                На каждого пассажира необходим свой заграничный паспорт, срок действия которого не менее 6 мес. с даты окончания круиза\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "byhand-submit--b" },
                [
                  !_setup.dobook.wait
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--blue",
                          on: { click: _setup.bookit },
                        },
                        [_vm._v("бронировать")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _setup.dobook.wait
                    ? _c(_setup.Loader, {
                        staticClass: "byhand-submit--loader",
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _setup.dobook.error
                ? _c("div", { staticClass: "error-list byhand-submit--c" }, [
                    _vm._v(
                      "\n                Заявка не создана\n                "
                    ),
                    _c("div", { staticClass: "error-list--li" }, [
                      _vm._v(_vm._s(_setup.dobook.error)),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bhform-row" }, [
      _c("div", { staticClass: "bhform-row--text" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "Для корректного бронирования, пожалуйста, укажите ссылку на круиз с сайта туроператора."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Если вы бронируете несколько кают, укажите номера совместно бронируемых заявок. "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Если необходимо применение дополнительных скидок на круиз-укажите в комментарии и прикрепите соответствующие документы к заявке. "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Сообщите иные существенные пожелания и комментарии."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "После бронирования заявки у туроператора мы дополнительно согласуем с вами стоимость и фактическую величину агентского вознаграждения с учетом промо прайсов, акций и т.д. - отслеживайте сообщения по заявкам."
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "bhform-row",
        staticStyle: { "justify-content": "center" },
      },
      [
        _c("div", { staticClass: "cabins-guests__header" }, [
          _vm._v("Данные круиза"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cabin__header cabin-header" }, [
      _c("div", { staticClass: "cabin-header__content" }, [
        _c("div", { staticClass: "cabin-header__title" }, [
          _vm._v("Пассажиры каюты"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cabin__header cabin-header" }, [
      _c("div", { staticClass: "cabin-header__content" }, [
        _c("div", { staticClass: "cabin-header__title" }, [_vm._v("Заказчик")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "cabin__header cabin-header" }, [
      _c("div", { staticClass: "cabin-header__content" }, [
        _c("div", { staticClass: "cabin-header__title" }, [
          _vm._v("Комментарии и скидки"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }